// extracted by mini-css-extract-plugin
module.exports = {"hotlines":"Hotlines-module--hotlines--2dRg2","name":"Hotlines-module--name--1wFyB","phone":"Hotlines-module--phone--3MCTX"};